package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.element.FloatingElementDto
import com.exura.features.plandefinition.domain.model.element.FloatingElement
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Mapper for converting between FloatingElement domain model and DTO.
 * Implements PlanElementMappers for Firebase storage compatibility.
 */
class FloatingElementMappers : PlanElementMappers<FloatingElement, FloatingElementDto> {
    override fun toDto(model: FloatingElement): FloatingElementDto = FloatingElementDto(
        elementType = model.elementType.name,
        durationInMinutes = model.durationInMinutes,
        durationInDays = model.durationInDays(),
        title = model.title,
        instruction = model.instruction,
        deadline = model.deadline,
        exactTime = model.exactTime,
        imageUrl = model.imageUrl,
    )

    override fun toDomain(dto: FloatingElementDto, collection: CollectionReference?, id: String?): FloatingElement = FloatingElement(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        title = dto.title,
        instruction = dto.instruction,
        deadline = dto.deadline,
        exactTime = dto.exactTime,
        imageUrl = dto.imageUrl,
        durationInMinutes = dto.durationInMinutes,
    )
}
